module.exports = __webpack_public_path__ + "static/media/trade_1.abc62998.svg";